import WaveDivider from "../../home/components/WaveDivider";
import type { ServiceStep } from "../../../mocks/servicePages";

interface HowItWorksProps {
  steps: ServiceStep[];
}

export default function HowItWorks({ steps }: HowItWorksProps) {
  return (
    <div>
      <section className="py-20" style={{ background: "#6CC412" }}>
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
              <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Simple Process</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-cl-dark leading-tight">
              Here&apos;s how it works.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {steps.map((step) => (
              <div key={step.step} className="bg-white rounded-3xl p-8 cartoon-card relative">
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-cl-dark border-2 border-cl-dark cartoon-shadow-sm mb-6 flex-shrink-0">
                  <span className="text-white font-black text-lg">{step.step}</span>
                </div>

                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-cl-lime border-2 border-cl-dark mb-5 cartoon-shadow-sm">
                  <i className={`${step.icon} text-cl-dark text-2xl`}></i>
                </div>

                <h3 className="text-cl-dark font-black text-xl mb-3">{step.title}</h3>
                <p className="text-cl-dark/70 text-sm leading-relaxed font-semibold">{step.desc}</p>

                {step.step < steps.length && (
                  <div className="hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 w-8 h-8 items-center justify-center rounded-full bg-cl-dark z-10 border-2 border-cl-dark cartoon-shadow-sm">
                    <i className="ri-arrow-right-line text-white text-sm font-black"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <WaveDivider fromColor="#6CC412" toColor="#ffffff" flip />
    </div>
  );
}
